import React from 'react'
import WithDefaultIconProps from './WithDefaultIconProps'

const IconStar = (props) =>
  <svg
    {...props}
    className='octicon octicon-star'
    viewBox='0 0 14 16'
  >
    <path fillRule='evenodd' d='M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74z' />
  </svg>

export default WithDefaultIconProps(IconStar)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/icons/IconStar.js